import { hamburgerButtonTemplate } from './hamburger-button.template';
import { hamburgerButtonStyles } from './hamburger-button.styles';
import { attr, FASTElement, observable } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { CSSClassBehavior } from '../../decorators/class-list-decorator';
import { ButtonVariant } from '../../styles/patterns/button';

/**
 * @element natgen-hamburger-button
 */
export class NatGenHamburgerButton extends FASTElement {
    @attr
    public variant: ButtonVariant;

    @attr
    public color: string;
    
    @observable opened: boolean = false;

    toggleOpened(e: Event, onlyControl = false) {
        if (!onlyControl || (e.target as HTMLElement).classList.contains('overlay'))
            this.opened = !this.opened;

        return true;
    }

    connectedCallback(): void {
        super.connectedCallback();
        
        this.variant = this.variant || 'stealth';
        this.color = this.color || 'primary';

        this.$fastController.addBehavior(new CSSClassBehavior('opened', 'opened', 'closed'));
    }
}

export const natGenHamburgerButtonDefinition = NatGenHamburgerButton.compose({
    name: `${NatGenDesignSystem.prefix}-hamburger-button`,
    template: hamburgerButtonTemplate(),
    styles: hamburgerButtonStyles
});
